import { Injectable, OnDestroy } from '@angular/core';
import { EventsProviderService } from './providers/events.provider.service';
import { UtilityService } from './util/utility.service';
import { SportsService } from './sports.service';
import { Subscription, Subject, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { PageType, StreamType, SBVSelectionType, ErrorLevel, BetOrderingType, EventMappingType, TimeFilter, SpecialOfferType } from '../models/enums';
import { ISportRegionCompetitionSelection } from '../models/sportHierarchy/sportRegionCompetitionSelection.interface';
import { EventVM } from '../models/event/event';
import { IEventsAndSelections } from '../models/event/eventsAndSelections.interface';
import { TestModel } from '../models/testmodel';
import { SettingsService } from './settings.service';
import { IBet } from '../models/bet/bet';
import { IBetTypeGroup } from '../models/betType/betTypeGroup.interface';
import { IBetTypeShowTypeWithBets } from '../models/bet/betsAndBetTypeShowTypeWithOnlineStatus.interface';
import { IBetTypeSelection } from '../models/betType/betTypeSelection.interface';
import { LocaleHelper } from 'src/locale/LocaleHelper';
import { UserService } from './user.service';
import { IEventsList } from '../models/event/eventsList.interface';
import { ICheckForVideoStreamResponse } from '../models/event/checkForVideoStreamResponse.intreface';
import { ICustomNotification } from '../models/notification/customNotification';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { NotificationService } from './notification.service';
import { CacheChangesService } from './cacheChanges.service';
import { CacheService } from './cache.service';
import { StorageService } from './util/storage.service';
import { SportsProviderService } from './providers/sports.provider.service';
import { IEventsAndSelectionsMobileLive } from '../models/event/eventsAndSelectionsMobileLive.interface';
import { IEventsListLive } from '../models/event/eventsListLive.interface';
import { IEventLiveResultInfo } from '../models/event/eventLiveResultInfo.interface';
import { ISportsWithEventsAndSelections } from '../models/event/sportsWithEventsAndSelections.interface';
import { ISportWithEventsAndSelectionsTO } from '../models/event/transportObjects/sportWithEventsAndSelectionsTo.interface';
import { ConstantValues } from '../models/util/constantValues';
import { ISportWithEventsAndSelections } from '../models/event/sportWithEventsAndSelections.interface';
import { IRegion } from '../models/sportHierarchy/region';
import { ICompetition } from '../models/sportHierarchy/competition.iterface';
import { ISport } from '../models/sportHierarchy/sport';
import { IEvenResultsAndScoreGroups } from '../models/results/evenResultsAndScoreGroups.interface';
import { IEventResult } from '../models/results/eventResult.interface';
import { ModelMapperService } from './util/model.mapper.service';
import { IBetOutcome } from '../models/bet/betOutcome.interface';
import { IBetTypeShowType } from '../models/betType/betTypeShowType.interface';
import { IOutcomeCodeValue } from '../models/betType/outcomeCodeValue.interface';
import { IOutcomeAndCodeValue } from '../models/bet/betOutcomeAndCodeValue';
import { IEventSrc } from '../models/event/eventSrc.interface';
import { ViewConfigurations } from '../models/util/viewConfigurations';

@Injectable()
export class EventsService implements OnDestroy {
  private subscription: Subscription = new Subscription();
  private srcSelection: ISportRegionCompetitionSelection;
  private isLive = false;
  private showStream = false;
  private expandedEvent: EventVM = null;
  private expandedEventResult: IEventResult = null;
  private lastExpandedEventResult: IEventResult = null;
  private lastExpandedEvent: EventVM = null;
  private languageCulture: string;
  private orderEventsByTimee = false;
  public favoriteLiveEventIds: number[] = [];
  public widgetSeted = false;



  // private eventsLoadedSource = new Subject<void>();
  // public eventsLoaded$ = this.eventsLoadedSource.asObservable();
  private expandedEventSource = new Subject<EventVM>();
  private showStreamSource = new Subject<{ showStream: boolean; betRadarEventId: number; liveStreamId: number; sportId: number }>();
  public expandedEvent$ = this.expandedEventSource.asObservable();
  private expandedEventResultSource = new Subject<IEventResult>();
  public expandedEventResult$ = this.expandedEventResultSource.asObservable();
  public showStream$ = this.showStreamSource.asObservable();
  private eventsOrderChangedSource = new Subject<boolean>();
  public eventsOrderChanged$ = this.eventsOrderChangedSource.asObservable();
  private headToHeadBetRadarEventIdSource = new Subject<number>();
  public headToHeadBetRadarEventIdChanged$ = this.headToHeadBetRadarEventIdSource.asObservable();
  private getEventsAndSelectionsSource = new Subject<void>();
  public getEventsAndSelectionsChanged$ = this.getEventsAndSelectionsSource.asObservable();
  private matchPreviewWidgetSource = new Subject<number>();
  public matchPreviewWidgetChanged$ = this.matchPreviewWidgetSource.asObservable();

  private widgetErrorSource = new Subject<boolean>();
  public widgetError$ = this.widgetErrorSource.asObservable();


  constructor(
    private sportsService: SportsService,
    private sportsProvider: SportsProviderService,
    private eventsProvider: EventsProviderService,
    private modelMapper: ModelMapperService,
    private utilityService: UtilityService,
    private settingsService: SettingsService,
    private storage: StorageService,
    private notificationService: NotificationService,
    private cacheChangesService: CacheChangesService,
    private cacheService: CacheService,
    private storageService: StorageService
  ) {
    this.languageCulture = LocaleHelper.cultureName[storage.language];

    this.subscription.add(sportsService.srcSelectionChanged$.subscribe(() => {
      if (this.srcSelection?.sport?.id !== this.sportsService.sportRegionCompetitionSelection?.sport?.id ||
        this.srcSelection?.region?.id !== this.sportsService.sportRegionCompetitionSelection?.region?.id ||
        this.srcSelection?.competition?.id !== this.sportsService.sportRegionCompetitionSelection?.competition?.id) {
        this.expandEvent(null);
        this.expandEventResult(null);
      }
      this.srcSelection = {
        sport: this.sportsService.sportRegionCompetitionSelection.sport,
        region: this.sportsService.sportRegionCompetitionSelection.region,
        competition: this.sportsService.sportRegionCompetitionSelection.competition,
      };
    }));
    // if (utilityService.mobileView) {
    //   this.orderEventsByTimee = true;
    // }
  }


  public openCloseHeadToHeadWidget(betRadaraEventId?: number) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    betRadaraEventId ? this.headToHeadBetRadarEventIdSource.next(betRadaraEventId) : this.headToHeadBetRadarEventIdSource.next(-1);
  }

  public openCloseMatchPreviewWidget(betRadaraEventId?: number) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    betRadaraEventId ? this.matchPreviewWidgetSource.next(betRadaraEventId) : this.matchPreviewWidgetSource.next(-1);
  }

  public addRemoveFavorites(event: EventVM) {
    const eventSRC: IEventSrc = {
      sportId: event.sportId,
      regionId: event.regionId,
      competitionId: event.competitionId,
      eventId: event.id,
      addedDate: new Date()
    };
    if (event.isInFavorite) {
      this.cacheService.removeEventFromFavorites(eventSRC);
    } else {
      this.cacheService.addEventTofavorites(eventSRC);
    }

  }

  toggleFavorites(event: EventVM) {
    if (event.isInFavorite) {
      event.isInFavorite = false;
      this.favoriteLiveEventIds.splice(this.favoriteLiveEventIds.indexOf(event.id), 1);
      this.storageService.favoriteLiveEvents = this.favoriteLiveEventIds;
    } else {
      event.isInFavorite = true;
      this.favoriteLiveEventIds.push(event.id);
      this.storageService.favoriteLiveEvents = this.favoriteLiveEventIds;
    }
    this.getEventsAndSelectionsSource.next();
  }

  addItemsFromTicketToFavorites(eventSrcs: IEventSrc[], isMobileView: boolean){
    for (const eventSRC of eventSrcs) {
      if (isMobileView) {
        if (this.favoriteLiveEventIds.includes(eventSRC.eventId)) {
          continue;
        }
        // event.isInFavorite = true;
        this.favoriteLiveEventIds.push(eventSRC.eventId);
        this.storageService.favoriteLiveEvents = this.favoriteLiveEventIds;
        this.getEventsAndSelectionsSource.next();
      } else {
        this.cacheService.addEventTofavorites(eventSRC);
      }
    }
  }

  widgetError(error: boolean): void {
    this.widgetErrorSource.next(error);
  }

  public expandedEventGet(): EventVM {
    return this.expandedEvent;
  }

  get orderEventsByTime(): boolean {
    return this.orderEventsByTimee;
  }

  set orderEventsByTime(orderByTime: boolean) {
    if (this.orderEventsByTimee !== orderByTime) {
      this.orderEventsByTimee = orderByTime;
      this.eventsOrderChangedSource.next(this.orderEventsByTimee);
    }
  }

  public expandEventResultGet(): IEventResult {
    return this.expandedEventResult;
  }

  removeExpandedEventFromOffer() {
    if (!this.expandEvent) {
      this.cacheChangesService.unsubscribeForExpanded();
      return;
    }

    this.cacheChangesService.unsubscribeForEventExpanded(this.expandedEvent.isLive);

    const notification: ICustomNotification = {
      title: DynamicTranslations.notification_title,
      message: DynamicTranslations.notification_selectedEventRemoved_ErrorMessage,
      errorLevel: ErrorLevel.Notification
    } as ICustomNotification;
    this.notificationService.forwardDataToNotification(notification);
    this.expandEvent(null);
  }

  public getEventsForCompetition(eventMappingTypes: EventMappingType[] = ViewConfigurations.showSpecialEventsInStandardOffer ? null : [EventMappingType.StandardEvent, EventMappingType.EventOfDay]): Observable<{ [id: number]: EventVM }> {
    if (!this.srcSelection.competition) {
      return of({});
    }
    // prob in response i will get selections
    const dates = this.utilityService.getDateFromTo(this.isLive, this.sportsService.timeFilterValueGet);
    return this.eventsProvider.getEventsForCompetition(
      this.srcSelection.sport.id,
      this.srcSelection.competition.id,
      dates.dateFrom, dates.dateTo,
      this.isLive,
      eventMappingTypes)
      .pipe(
        switchMap(async (eventsTO) => {
          const eventsDictionary: { [id: number]: EventVM } = {};
          const betTypeShowTypes = await this.settingsService.getBetTypeShowTypes().toPromise();
          eventsTO.forEach((e) => {
            const ev: EventVM = this.modelMapper.mapEvent(e, this.srcSelection.sport.name, this.srcSelection.competition.regionName, this.srcSelection.competition.name, this.languageCulture, this.utilityService.eventsDateToStringFormat, true, this.cacheService.eventsForNotifications.includes(e.id), betTypeShowTypes);
            if (eventMappingTypes && eventMappingTypes.length > 0) {
              if (!eventMappingTypes.includes(ev.mappingType)) {
                return;
              }
            }

            // set showBetId on group here
            Object.entries(ev.betGroups).forEach(([, group]) => {
              Object.entries(group.bets).forEach(([, bet]) => bet.betOutcomes.forEach((o) => o.isSelected = this.storage.isOutcomeInTicket(ev.id, o.id)));
            });
            eventsDictionary[ev.id] = ev;
          });
          return eventsDictionary;
        }),
      );
    //   // ovde ako je u linku event ili dodavanje na tiket selektuj kvotu ili expanduje event
  }

  // prob this function wont be needed
  public getEventsWithSelections(orderByCompetition: boolean, events: { [id: number]: EventVM }): IEventsAndSelections {
    const eventsListsDictionary: { [id: number]: IEventsList } = {};
    const eventsWithSelections: IEventsAndSelections = {
      eventsLists: [],
      selections: []
    };
    const selections: IBetTypeSelection[] = [];
    if (orderByCompetition) {
      // load selections competitions and group events per competition
      Object.entries(events).map(([, ev]) => {
        // remove this later
        // if (!selections) {
        //   selections = TestModel.betTypeSelections.filter(s => s.sportId === ev.sportId);
        // }
        if (!eventsListsDictionary[ev.competitionId]) {
          eventsListsDictionary[ev.competitionId] = {
            // here should get selections for competition and fill btos from betTypeShow types
            events: [],
            sportId: ev.sportId,
            regionId: ev.regionId,
            competitionId: ev.competitionId,
            sportName: ev.sportName,
            regionName: ev.regionName,
            competitionName: ev.competitionName,
          };
        }
        eventsListsDictionary[ev.competitionId].events.push(ev);
      });
    } else {
      Object.entries(events).map(([, ev]) => {
        if (!eventsListsDictionary[ev.sportId]) {
          eventsListsDictionary[ev.sportId] = {
            // here should get selections for competition and fill btos from betTypeShow types
            events: [],
            sportId: ev.sportId,
            regionId: ev.regionId,
            competitionId: ev.competitionId,
            sportName: ev.sportName,
            regionName: ev.regionName,
            competitionName: ev.competitionName,
          };
        }
        eventsListsDictionary[ev.sportId].events.push(ev);
      });
    }
    eventsWithSelections.selections = selections;
    eventsWithSelections.selections.map(async bts => {
      const btosAndSvbDisplayType = await this.settingsService.getBetTypeOutcomesAndSbvDisplayTypeForSelection(bts);
      bts.betTypeOutcomes = btosAndSvbDisplayType.betTypeOutcomes;
      bts.sbvDispalyType = btosAndSvbDisplayType.sbvDisplayType;
    });
    Object.entries(eventsListsDictionary).map(([, eventList]) => {
      this.utilityService.sortEventsByDateAndCode(eventList.events);
      eventsWithSelections.eventsLists.push(eventList);
    });

    return eventsWithSelections;
  }

  // getEventsWithSelectionsForSportFromTableConfigs(events: { [id: number]: EventVM }, sportId: number, isLive: boolean): Observable<IEventsAndSelections> {
  //   return this.eventsProvider.getEventsColumnDefinitions(sportId, isLive).pipe(
  //     map((tconfig) => {
  //       const selections = this.modelMapper.mapBetTypeSelectionsFromTableConfig(tconfig, sportId);
  //       return this.getEventsWithSelectionsForOrdering(true, events, selections);
  //     })
  //   );
  // }

  // getEventsWithSelectionsForOrdering(orderByCompetition: boolean, events: { [id: number]: EventVM }, selections: IBetTypeSelection[], getBetTypeOutcomesForSelection: boolean = true): IEventsAndSelections {
  //   const eventsListsDictionary: { [id: number]: IEventsList } = {};
  //   const eventsWithSelections: IEventsAndSelections = {
  //     eventsLists: [],
  //     selections: []
  //   };
  //   if (orderByCompetition) {
  //     Object.entries(events).map(([, ev]) => {
  //       if (!eventsListsDictionary[ev.competitionId]) {
  //         eventsListsDictionary[ev.competitionId] = {
  //           // here should get selections for competition and fill btos from betTypeShow types
  //           events: [],
  //           sportId: ev.sportId,
  //           regionId: ev.regionId,
  //           competitionId: ev.competitionId,
  //           sportName: ev.sportName,
  //           regionName: ev.regionName,
  //           competitionName: ev.competitionName,
  //         };
  //       }
  //       eventsListsDictionary[ev.competitionId].events.push(ev);
  //     });
  //   } else {
  //     Object.entries(events).map(([, ev]) => {
  //       if (!eventsListsDictionary[ev.sportId]) {
  //         eventsListsDictionary[ev.sportId] = {
  //           // here should get selections for competition and fill btos from betTypeShow types
  //           events: [],
  //           sportId: ev.sportId,
  //           regionId: ev.regionId,
  //           competitionId: ev.competitionId,
  //           sportName: ev.sportName,
  //           regionName: ev.regionName,
  //           competitionName: ev.competitionName,
  //         };
  //       }
  //       eventsListsDictionary[ev.sportId].events.push(ev);
  //     });
  //   }

  //   eventsWithSelections.selections = selections;
  //   this.utilityService.sortByOrderNumber(eventsWithSelections.selections);
  //   if (getBetTypeOutcomesForSelection) {
  //     eventsWithSelections.selections.map(async bts => {
  //       const btosAndSvbDisplayType = await this.settingsService.getBetTypeOutcomesAndSbvDisplayTypeForSelection(bts);
  //       bts.betTypeOutcomes = btosAndSvbDisplayType.betTypeOutcomes;
  //       bts.sbvDispalyType = btosAndSvbDisplayType.sbvDisplayType;
  //     });
  //   }
  //   Object.entries(eventsListsDictionary).map(([, eventList]) => {
  //     this.utilityService.sortEventsByDateAndCode(eventList.events);
  //     eventsWithSelections.eventsLists.push(eventList);
  //   });
  //   return eventsWithSelections;
  // }

  getEventsForSportLive(sportId: number): { [id: number]: EventVM } {
    const events: { [id: number]: EventVM } = {};
    const liveSport = TestModel.liveSportsWithSelections.find(s => s.id === sportId);
    if (!liveSport) {
      return;
    }

    liveSport.regions.forEach(reg => {
      reg.competitions.forEach(cmp => {
        // set showBetId on group here
        //  cmp.events.forEach(ev => events[ev.id] = this.modelMapper.mapEvent(ev, liveSport.name, reg.name, cmp.name, this.languageCulture, this.utilityService.eventsDateToStringFormat, true, this.cacheService.eventsForNotifications.includes(ev.id)));
      });
    });
    return events;
  }

  public expandEvent(event: EventVM): void {
    if (event && (!this.lastExpandedEvent || this.lastExpandedEvent.id !== event.id)) {
      this.lastExpandedEvent = event;
    }
    if (!event || (this.expandedEvent && this.expandedEvent.id === event.id)) {
      this.expandedEvent = null;
      this.expandedEventSource.next(null);
      this.utilityService.changeParentEventUrl();
      return;
    }
    this.expandedEvent = event;
    this.showHideStream(null, null, false, null);
    this.expandedEventSource.next(event);
    this.utilityService.changeParentEventUrl(event.id, event.eventName);
  }

  public expandLastExpandedEvent() {
    if (!this.lastExpandedEvent) {
      return;
    } else {
      if (!this.lastExpandedEvent.isLive) {
        return;
      }
      this.expandEvent(this.lastExpandedEvent);
    }
  }

  public expandEventResult(eventResult: IEventResult): void {
    if (eventResult && (!this.lastExpandedEventResult || this.lastExpandedEventResult.eventId !== eventResult.eventId)) {
      this.lastExpandedEventResult = eventResult;
    }
    if (!eventResult || (this.expandedEventResult && this.expandedEventResult.eventId === eventResult.eventId)) {
      this.expandedEventResult = null;
      this.utilityService.changeParentEventUrl();
      this.expandedEventResultSource.next(null);
      return;
    }
    this.expandedEventResult = eventResult;
    this.utilityService.changeParentEventUrl(eventResult.eventId, eventResult.eventName);
    this.expandedEventResultSource.next(eventResult);
    // this.showHideStream(null, null, false, null);
  }

  public expandLastExpandedEventResult() {
    if (!this.lastExpandedEventResult) {
      return;
    }
    this.expandEventResult(this.lastExpandedEventResult);
  }

  public getBetsAndGroups(event: EventVM): Observable<{ bets: IBet[]; groups: IBetTypeGroup[] }> {
    return this.eventsProvider.getBetsAndGroups(event.sportId, event.regionId, event.competitionId, event.id).pipe(
      switchMap(async (bag) => {
        const btst = await this.settingsService.getBetTypeShowTypes().toPromise();
        return this.modelMapper.mapBetsAndGroups(bag, event.isLive, true, btst);
      }));
  }

  public getResultedBetsAndGroups(eventResult: IEventResult): Observable<{ bets: IBet[]; groups: IBetTypeGroup[] }> {
    return this.eventsProvider.getResultedBetsAndGroups(eventResult.sportId, eventResult.regionId, eventResult.competitionId, eventResult.eventId).pipe(
      switchMap(async (bag) => {
        const btst = await this.settingsService.getBetTypeShowTypes().toPromise();
        return this.modelMapper.mapBetsAndGroups(bag, false, true, btst);
      }));
  }

  // can be moved to another service
  setOnlineForBetTypeGroups(groups: IBetTypeGroup[], betsAndBetTypeShowType: { [betTypeId: number]: IBetTypeShowTypeWithBets }): boolean {
    let isAnyGroupActive = false;
    groups.forEach(group => {
      if (group.id === -1) {
        group.isOnline = true;
        return;
      }
      if (group.betTypeGroupingTemplateItems && group.betTypeGroupingTemplateItems.length > 0) {
        for (const templateItem of group.betTypeGroupingTemplateItems) {
          if (betsAndBetTypeShowType[templateItem.betTypeId]
            && betsAndBetTypeShowType[templateItem.betTypeId].isAnyBetPlayable) {
            group.isOnline = true;
            isAnyGroupActive = true;
            break;
          } else {
            // if (group.isSelected) {
            //   isAnyGroupActive = true;
            // }
            group.isOnline = false;
          }
        }
      } else {
        group.isOnline = false;
      }
    });
    return isAnyGroupActive;
  }

  setOnlineForResultBetTypeGroups(groups: IBetTypeGroup[], betsAndBetTypeShowType: { [betTypeId: number]: IBetTypeShowTypeWithBets }): boolean {
    let reFilterGroup = false;
    groups.forEach(group => {
      if (group.betTypeGroupingTemplateItems && group.betTypeGroupingTemplateItems.length > 0) {
        for (const templateItem of group.betTypeGroupingTemplateItems) {
          if (betsAndBetTypeShowType[templateItem.betTypeId]
            && betsAndBetTypeShowType[templateItem.betTypeId].isAnyBetPlayable) {
            group.isOnline = true;
            break;
          } else {
            if (group.isSelected) {
              reFilterGroup = true;
            }
            group.isOnline = false;
          }
        }
      } else {
        group.isOnline = false;
      }
    });
    return reFilterGroup;
  }

  getBetsAndBetTypeShowTypeForBetTypeGroup(group: IBetTypeGroup, betsAndBetTypeShowType: { [betTypeId: number]: IBetTypeShowTypeWithBets }): { [betTypeId: number]: IBetTypeShowTypeWithBets } {
    let filtered: { [betTypeId: number]: IBetTypeShowTypeWithBets } = {};
    if (!group.betTypeGroupingTemplateItems) {
      if (group.betTypeIds == null) {
        filtered = betsAndBetTypeShowType;
      } else {
        group.betTypeIds.forEach(betTypeId => {
          if (betsAndBetTypeShowType[betTypeId]) {
            filtered[betTypeId] = betsAndBetTypeShowType[betTypeId];
          }
        });
      }
    } else {
      group.betTypeGroupingTemplateItems.forEach(bTGTItem => {
        const betTypeShowTypeWithBets: IBetTypeShowTypeWithBets = betsAndBetTypeShowType[bTGTItem.betTypeId];
        if (!betTypeShowTypeWithBets) {
          return;
        }
        betTypeShowTypeWithBets.mostBalancedBetIndex = -1;

        if (bTGTItem.sbvSelectionType === SBVSelectionType.MostBalanced) {
          // betTypeShowTypeWithBets.mostBalancedBetIndex = this.utilityService.getMostBalancedBetIndexFromBetProperty(betTypeShowTypeWithBets.bets);
          // use this if isMostBalanced Prop does not work !!!!!!!!
          betTypeShowTypeWithBets.mostBalancedBetIndex = this.utilityService.getMostBalancedBetIndex(betTypeShowTypeWithBets.bets);
        }
        filtered[bTGTItem.betTypeId] = betTypeShowTypeWithBets;
      });
    }
    for (const betTypeId of Object.keys(filtered)) {
      for (const bet of betsAndBetTypeShowType[+betTypeId].bets) {
        if (betsAndBetTypeShowType[+betTypeId].betTypeShowType.betOrderingType !== BetOrderingType.NoOrdering) {
          this.utilityService.sortBetOutcomesByOrderingType(bet.betOutcomes, betsAndBetTypeShowType[+betTypeId].betTypeShowType.betOrderingType);
        }
        const btoKVp = Object.entries(bet.betOutcomesDic);
        for (const [, betOutcomes] of btoKVp) {
          if (betsAndBetTypeShowType[+betTypeId].betTypeShowType.betOrderingType !== BetOrderingType.NoOrdering) {
            this.utilityService.sortBetOutcomesByOrderingType(betOutcomes, betsAndBetTypeShowType[+betTypeId].betTypeShowType.betOrderingType);
          }
          if (bet.isPlayable && bet.isInOffer) {
            if (bet.betOutcomes) {
              for (const bto of betOutcomes) {
                if (bto.isPlayable && bto.isInOffer) {
                  betsAndBetTypeShowType[+betTypeId].isAnyBetPlayable = true;
                }
              }
            }
          }
        }
      }
      if (betsAndBetTypeShowType[+betTypeId].betTypeShowType.betOrderingType !== BetOrderingType.NoOrdering) {
        this.utilityService.sortBetsByOrderingType(betsAndBetTypeShowType[+betTypeId].bets, betsAndBetTypeShowType[+betTypeId].betTypeShowType.betOrderingType);
      }
      // this.setIsAnyBetPlayableForBetTypeShowTypeWithBets(betsAndBetTypeShowType[+betTypeId], isResultsPage);
    }
    return filtered;
  }

  setIsAnyBetPlayableForBetTypeShowTypeWithBets(betTypeShowTypeWithBets: IBetTypeShowTypeWithBets, isResultsPage: boolean) {
    betTypeShowTypeWithBets.isAnyBetPlayable = false;
    for (const bet of betTypeShowTypeWithBets.bets) {

      if ((!bet.isInOffer || !bet.isPlayable) && !isResultsPage) {
        continue;
      }
      if (bet.betOutcomes) {
        bet.hasPlayableOutcomes = false;
        if (isResultsPage && bet.betOutcomes.length > 0) {
          betTypeShowTypeWithBets.isAnyBetPlayable = true;
          break;
        }
        for (const outcome of bet.betOutcomes) {
          if (outcome.isInOffer && outcome.isPlayable) {
            bet.hasPlayableOutcomes = true;
            betTypeShowTypeWithBets.isAnyBetPlayable = true;
            break;
          }
        }
        // if (betTypeShowTypeWithBets.isAnyBetPlayable) {
        //   break;
        // }
      }

      // if (bet.isPlayable && bet.isInOffer || isResultsPage) {
      //   if (bet.betOutcomes) {
      //     if (isResultsPage && bet.betOutcomes.length > 0) {
      //       betTypeShowTypeWithBets.isAnyBetPlayable = true;
      //       return;
      //     }
      //     for (const bto of bet.betOutcomes) {
      //       if (bto.isPlayable && bto.isInOffer) {
      //         betTypeShowTypeWithBets.isAnyBetPlayable = true;
      //       }
      //     }
      //   }
      // }
    }
  }

  checkForVideoStream(events: EventVM[]): Observable<ICheckForVideoStreamResponse[]> {
    return this.eventsProvider.checkForVideoStream(events.map(ev => ev.betRadarEventId));
  }

  getLiveStreamUrl(eventId: number, streamType: StreamType): Observable<string> {
    return this.eventsProvider.getLiveStreamUrl(eventId, streamType).pipe(
      map(videoStream => {
        if (!videoStream) {
          return null;
        }
        return videoStream.url;
      }));
  }

  showHideStream(betRadarEventId?: number, liveStreamId?: number, showStream?: boolean, sportId?: number) {
    if (showStream) {
      this.showStream = showStream;
    } else {
      this.showStream = !this.showStream;
    }

    this.showStreamSource.next({ showStream: this.showStream, betRadarEventId, liveStreamId, sportId });
  }

  getEventsForSearch(searchValue: string): Observable<EventVM[]> {
    return this.eventsProvider.getEventsForSearch(searchValue, false).pipe(
      switchMap(value => {
        const events: EventVM[] = [];
        return of(value.map(e => this.modelMapper.mapEventFromV2(e, this.languageCulture, this.utilityService.eventsDateToStringFormat, false)));
      }),
    );
  }

  filterBets(filterValue: string, bets: IBet[], betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType }): IBet[] {
    return bets.filter(bet =>
      (betTypeShowTypes[bet.betTypeId] && betTypeShowTypes[bet.betTypeId].betTypeName?.toLowerCase().includes(filterValue))
      || bet.outrightName.includes(filterValue));
  }

  filterOutcomeCodeValuesByProps(
    filterValue: string,
    outcomeCodeValues: IOutcomeCodeValue[],
    byCode?: boolean,
    byValue?: boolean,
    byBetTypeCode?: boolean,
    byOutcomeCode?: boolean,
  ): IOutcomeCodeValue[] {
    return outcomeCodeValues.filter(ocv =>
      byCode ? (ocv.code ? ocv.code.includes(filterValue) : false) : false ||
        // tslint:disable-next-line:triple-equals
        byValue ? ocv.value === +filterValue : false ||
          byBetTypeCode ? (ocv.betTypeCode ? ocv.betTypeCode.includes(filterValue) : false) : false ||
            byOutcomeCode ? (ocv.outcomeCode ? ocv.outcomeCode.includes(filterValue) : false) : false);
  }

  private filterBetOutcomes(filterValue: string, betOutcomes: IBetOutcome[], betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType }): IBetOutcome[] {
    return betOutcomes.filter(bo =>
    (betTypeShowTypes[bo.betTypeId] && betTypeShowTypes[bo.betTypeId].betTypeOutcomes[bo.betTypeOutcomeId]
      && (betTypeShowTypes[bo.betTypeId].betTypeOutcomes[bo.betTypeOutcomeId].name?.toLowerCase().includes(filterValue)
        || betTypeShowTypes[bo.betTypeId].betTypeOutcomes[bo.betTypeOutcomeId].shortName?.toLowerCase().includes(filterValue)
      )
    )
      // ||
    );
  }

  getOutcomesAndCodeValuesByCodeExact(filterValue: string, betOutcomes: IBetOutcome[], outcomeCodeValues: IOutcomeCodeValue[]): IOutcomeAndCodeValue[] {
    const filterValueLower = filterValue.toLowerCase();
    const filteredCodeValues =  outcomeCodeValues.filter(ocv => ocv.code?.toLowerCase() === filterValueLower);

    this.filterOutcomeCodeValuesByProps(filterValue, outcomeCodeValues, true, true);
    const outcomesAndCodeValues: IOutcomeAndCodeValue[] = [];

    const filteredBetOutcomes = betOutcomes.filter(bo =>
      (filteredCodeValues.findIndex(cv => cv.value ? cv.betTypeOutcomeId === bo.betTypeOutcomeId && cv.value.toString() === bo.sbv : cv.betTypeOutcomeId === bo.betTypeOutcomeId) > -1)
      && bo.isBetPlayable && bo.isPlayable && bo.isInOffer
    );
    for (const bto of filteredBetOutcomes) {
      const codValuesForBto = filteredCodeValues.filter(ocv => ocv.betTypeOutcomeId === bto.betTypeOutcomeId);
      outcomesAndCodeValues.push({
        betOutcome: bto,
        codeValue: codValuesForBto.length > 1  ? filteredCodeValues.find(ocv => ocv.value.toString() === bto.sbv) : codValuesForBto[0]
      });
    }
    return outcomesAndCodeValues;
  }

  getOutcomesAndCodeValuesByCodeBetsAndOutcomeProperties(filterValue: string, betOutcomes: IBetOutcome[], bets: IBet[], betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType }, outcomeCodeValues: IOutcomeCodeValue[]): IOutcomeAndCodeValue[] {
    const filterValueLower = filterValue.toLowerCase();
    const filteredBets = this.filterBets(filterValue, bets, betTypeShowTypes);
    const filteredCodeValues = this.filterOutcomeCodeValuesByProps(filterValue, outcomeCodeValues, true, true);
    const outcomesAndCodeValues: IOutcomeAndCodeValue[] = [];

    const filteredBetOutcomes = betOutcomes.filter(bo =>
      (
        (betTypeShowTypes[bo.betTypeId] && betTypeShowTypes[bo.betTypeId].betTypeOutcomes[bo.betTypeOutcomeId]
          && (betTypeShowTypes[bo.betTypeId].betTypeOutcomes[bo.betTypeOutcomeId].name?.toLowerCase().includes(filterValueLower)
            || betTypeShowTypes[bo.betTypeId].betTypeOutcomes[bo.betTypeOutcomeId].shortName?.toLowerCase().includes(filterValueLower)
          )
        )
        || (filteredBets.findIndex(b => b.id === bo.betId) > -1)
        || bo.name?.toLowerCase().includes(filterValueLower)
        || (filteredCodeValues.findIndex(cv => cv.value ? cv.betTypeOutcomeId === bo.betTypeOutcomeId && cv.value.toString() === bo.sbv : cv.betTypeOutcomeId === bo.betTypeOutcomeId) > -1)
      )
      && bo.isBetPlayable && bo.isPlayable && bo.isInOffer
    );
    for (const bto of filteredBetOutcomes) {
      outcomesAndCodeValues.push({
        betOutcome: bto,
        codeValue: outcomeCodeValues.find(ocv => ocv.betTypeOutcomeId === bto.betTypeOutcomeId)
      });
    }
    return outcomesAndCodeValues;
  }

  public getLiveEventsSelectionsAndSportOrdering(): Observable<{ events: { [id: number]: EventVM }; selectionsDictionary: { [hierarchyId: number]: IBetTypeSelection[] }; sportOrdering: number[] }> {
    // return this.sportsProvider.getLiveSports(null, true, true).pipe(
    //   switchMap((sws) => {
    //     const sportOrdering: number[] = [];

    //     const events: { [id: number]: EventVM } = {};
    //     const selectionsDictionary: { [hierarchyId: number]: { [betTypeId: number]: IBetTypeSelection } } = {};
    //     for (const sportWithSelections of sws) {
    //       sportOrdering.push(sportWithSelections.id);
    //       // this.cacheChangesService.subscribeForSportChanges(sportWithSelections.id, true);
    //       selectionsDictionary[sportWithSelections.id] = {};
    //       // const selections: IBetTypeSelection =
    //       sportWithSelections.selections.map(async s => {

    //         const mappedSelection: IBetTypeSelection = this.modelMapper.mapBetTypeSelection(s);
    //         selectionsDictionary[sportWithSelections.id][mappedSelection.betTypeId] = mappedSelection;
    //         mappedSelection.betTypeOutcomes = await this.settingsService.getBetTypeOutcomesForSelection(mappedSelection);

    //       });

    //       for (const region of sportWithSelections.regions) {

    //         for (const competition of region.competitions) {
    //           for (const eventTo of competition.events) {
    //             events[eventTo.id] = this.modelMapper.mapEvent(eventTo, sportWithSelections.name, region.name, competition.name, this.languageCulture, this.utilityService.eventsDateToStringFormat, true, this.cacheService.eventsForNotifications.includes(eventTo.id));
    //           }
    //         }
    //       }
    //     }
    //     return of({ events, selectionsDictionary, sportOrdering });
    //   })
    // );
    return this.cacheService.getLiveEventsSelectionsAndSportOrdering(this.languageCulture, this.utilityService.eventsDateToStringFormat);
  }

  getEventsWithSelectionsForOrderingMobileLive(orderBySport: boolean, events: { [id: number]: EventVM }, selectionsDictionary: { [hierarchyId: number]: IBetTypeSelection[] }, sportOrdering: number[], expandedSportIds: number[] = []): IEventsAndSelectionsMobileLive[] {
    const eventsListsDictionary: { [id: number]: IEventsListLive } = {};
    const favoriteEventsListsDictionary: { [id: number]: IEventsListLive } = {};
    const eventsWithSelectionsDictionary: { [id: number]: IEventsAndSelectionsMobileLive } = {};
    eventsWithSelectionsDictionary[-99] = {
      eventsLists: [],
      sportId: -99,
      eventsCount: 0,
      sportName: DynamicTranslations.favoriteButtonName,
      firstSelectionBySport: {},
      isExpanded: orderBySport && !expandedSportIds.includes(-99) ? false : true,
      selections: [],
      orderNumber: -1,
    };
    this.storage.favoriteLiveEvents = this.favoriteLiveEventIds;
    for (const [, ev] of Object.entries(events)) {

      if (this.favoriteLiveEventIds.find(id => id === ev.id)) {
        ev.isInFavorite = true;
      }

      if (!eventsWithSelectionsDictionary[ev.sportId]) {
        let index: number = sportOrdering.indexOf(ev.sportId);
        eventsWithSelectionsDictionary[ev.sportId] = {
          eventsLists: [],
          sportId: ev.sportId,
          eventsCount: 0,
          sportName: ev.sportName,
          firstSelectionBySport: {},
          isExpanded: orderBySport && !expandedSportIds.includes(ev.sportId) ? false : true,
          selections: selectionsDictionary[ev.sportId] ? selectionsDictionary[ev.sportId] : [],
          orderNumber: index > -1 ? index++ : 999,
        };
      }
      // if (orderBySport) {


      if (!eventsListsDictionary[ev.competitionId]) {
        const srcOrder = this.cacheService.getSrcOrderNumbers(ev.sportId, ev.regionId, ev.competitionId);
        eventsListsDictionary[ev.competitionId] = {
          events: [],
          sportId: ev.sportId,
          regionId: ev.regionId,
          competitionId: ev.competitionId,
          isExpanded: true,
          regionName: ev.regionName,
          competitionName: ev.competitionName,
          sportOrderNo: srcOrder.sportOrder,
          regionOrderNo: srcOrder.regionOrder,
          competitionOrderNo: srcOrder.competitionOrder

        };

        eventsWithSelectionsDictionary[ev.sportId].eventsLists.push(eventsListsDictionary[ev.competitionId]);
      }

      if (!favoriteEventsListsDictionary[ev.competitionId] && ev.isInFavorite) {
        const srcOrder = this.cacheService.getSrcOrderNumbers(ev.sportId, ev.regionId, ev.competitionId);
        favoriteEventsListsDictionary[ev.competitionId] = {
          events: [],
          sportId: ev.sportId,
          regionId: ev.regionId,
          competitionId: ev.competitionId,
          isExpanded: false,
          regionName: ev.regionName,
          competitionName: ev.competitionName,
          sportOrderNo: srcOrder.sportOrder,
          regionOrderNo: srcOrder.regionOrder,
          competitionOrderNo: srcOrder.competitionOrder
        };
        eventsWithSelectionsDictionary[-99].eventsLists.push(favoriteEventsListsDictionary[ev.competitionId]);
      }

      eventsListsDictionary[ev.competitionId].events.push(ev);
      if (ev.isInFavorite) {
        favoriteEventsListsDictionary[ev.competitionId].events.push(ev);
      }
    }

    return this.utilityService.sortByOrderNumber(
      Object.entries(eventsWithSelectionsDictionary).map(([, eventsAndSelections]) => {
        this.utilityService.sortByOrderNumber(eventsAndSelections.selections);
        if (eventsAndSelections.sportId > 0 && eventsAndSelections.selections[0]) {

          eventsWithSelectionsDictionary[-99].firstSelectionBySport[eventsAndSelections.sportId] = eventsAndSelections.selections[0];
        }
        eventsAndSelections.eventsLists = this.sortEventListsByRegionAndCompetitionOrder(eventsAndSelections.eventsLists);
        for (const eventsList of eventsAndSelections.eventsLists) {
          this.utilityService.sortEventsByDateAndCode(eventsList.events);
          eventsAndSelections.eventsCount += eventsList.events.length;
        }
        return eventsAndSelections;
      }));
  }

  public sortEventListsByRegionAndCompetitionOrder(eventLists: IEventsListLive[]): IEventsListLive[] {
    if (!eventLists || eventLists.length < 2) {
      return eventLists;
    } else {
      eventLists.sort((le1, el2) => {
        if (le1.regionOrderNo > el2.regionOrderNo) {
          return 1;
        }
        if (le1.regionOrderNo < el2.regionOrderNo) {
          return -1;
        }
        if (le1.competitionOrderNo > el2.competitionOrderNo) {
          return 1;
        }
        if (le1.competitionOrderNo < el2.competitionOrderNo) {
          return -1;
        }
        return 0;
      });
      return eventLists;
    }
  }

  // getEventsWithSelectionsForOrderingMobileLive(orderBySport: boolean, events: { [id: number]: EventVM }, selectionsDictionary: { [hierarchyId: number]: { [betTypeId: number]: IBetTypeSelection } }, sportOrdering: number[]): IEventsAndSelectionsMobileLive[] {
  //   const eventsListsDictionary: { [id: number]: IEventsListLive } = {};
  //   const favoriteEventsListsDictionary: { [id: number]: IEventsListLive } = {};
  //   const eventsWithSelectionsDictionary: { [id: number]: IEventsAndSelectionsMobileLive } = {};
  //   eventsWithSelectionsDictionary[-99] = {
  //     eventsLists: [],
  //     sportId: -99,
  //     eventsCount: 0,
  //     sportName: 'Favorite',
  //     firstSelectionBySport: {},
  //     isExpanded: orderBySport ? false : true,
  //     selections: [],
  //     orderNumber: -1,
  //   };
  //   this.storage.favoriteLiveEvents = this.favoriteLiveEventIds;
  //   for (const [, ev] of Object.entries(events)) {

  //     if (this.favoriteLiveEventIds.find(id => id === ev.id)) {
  //       ev.isInFavorite = true;
  //     }

  //     if (!eventsWithSelectionsDictionary[ev.sportId]) {
  //       let index: number = sportOrdering.indexOf(ev.sportId);
  //       eventsWithSelectionsDictionary[ev.sportId] = {
  //         eventsLists: [],
  //         sportId: ev.sportId,
  //         eventsCount: 0,
  //         sportName: ev.sportName,
  //         firstSelectionBySport: {},
  //         isExpanded: orderBySport ? false : true,
  //         selections: selectionsDictionary[ev.sportId] ? Object.entries(selectionsDictionary[ev.sportId]).map(([, v]) => v) : [],
  //         orderNumber: index > -1 ? index++ : 999,
  //       };
  //     }
  //     // if (orderBySport) {


  //     if (!eventsListsDictionary[ev.competitionId]) {
  //       eventsListsDictionary[ev.competitionId] = {
  //         events: [],
  //         sportId: ev.sportId,
  //         regionId: ev.regionId,
  //         competitionId: ev.competitionId,
  //         isExpanded: true,
  //         regionName: ev.regionName,
  //         competitionName: ev.competitionName,
  //       };

  //       eventsWithSelectionsDictionary[ev.sportId].eventsLists.push(eventsListsDictionary[ev.competitionId]);
  //     }

  //     if (!favoriteEventsListsDictionary[ev.competitionId] && ev.isInFavorite) {
  //       favoriteEventsListsDictionary[ev.competitionId] = {
  //         events: [],
  //         sportId: ev.sportId,
  //         regionId: ev.regionId,
  //         competitionId: ev.competitionId,
  //         isExpanded: false,
  //         regionName: ev.regionName,
  //         competitionName: ev.competitionName,
  //       };
  //       eventsWithSelectionsDictionary[-99].eventsLists.push(favoriteEventsListsDictionary[ev.competitionId]);
  //     }

  //     eventsListsDictionary[ev.competitionId].events.push(ev);
  //     if (ev.isInFavorite) {
  //       favoriteEventsListsDictionary[ev.competitionId].events.push(ev);
  //     }
  //   }

  //   return this.utilityService.sortByOrderNumber(
  //     Object.entries(eventsWithSelectionsDictionary).map(([, eventsAndSelections]) => {
  //       this.utilityService.sortByOrderNumber(eventsAndSelections.selections);
  //       if (eventsAndSelections.sportId > 0 && eventsAndSelections.selections[0]) {

  //         eventsWithSelectionsDictionary[-99].firstSelectionBySport[eventsAndSelections.sportId] = eventsAndSelections.selections[0];
  //       }
  //       for (const eventsList of eventsAndSelections.eventsLists) {
  //         this.utilityService.sortEventsByDateAndCode(eventsList.events);
  //         eventsAndSelections.eventsCount += eventsList.events.length;
  //       }
  //       return eventsAndSelections;
  //     }));
  // }

  getLiveResultsForEvents(eventIds: number[]): Observable<IEventLiveResultInfo[]> {
    return this.eventsProvider.getLiveResults(eventIds).pipe(
      map((lriDic) =>
        Object.entries(lriDic).map(([, v]) =>
          this.modelMapper.mapEventLiveResult(v)
        )
      )
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getSpecialOfferEventsMobile(specialOfferType: SpecialOfferType, dateFrom: Date, dateTo: Date): Observable<ISportsWithEventsAndSelections> {
    switch (specialOfferType) {
      case SpecialOfferType.EventOfDay:
        return this.eventsProvider.getSpecialOfferEventsMobile(ConstantValues.PAGE_ID_EVENTOFDAY, specialOfferType, dateFrom, dateTo).pipe(
          switchMap(async (res) => await this.getSportsWithEventsAndSelections(res.sportWithEventsList, specialOfferType, this.utilityService.eventsDateToStringFormat))
        );
        break;

      case SpecialOfferType.SuperBet:
        return this.eventsProvider.getSpecialOfferEventsMobile(ConstantValues.PAGE_ID_SUPERBET, specialOfferType, dateFrom, dateTo).pipe(
          switchMap(async (res) => await this.getSportsWithEventsAndSelections(res.sportWithEventsList, specialOfferType, this.utilityService.eventsDateToStringFormat))
        );
        break;

      case SpecialOfferType.Outrights:
        return this.eventsProvider.getSpecialOfferEventsMobile(ConstantValues.PAGE_ID_PM, specialOfferType, dateFrom, dateTo).pipe(
          switchMap(async (res) => await this.getSportsWithEventsAndSelections(res.sportWithEventsList, specialOfferType, this.utilityService.eventsDateToStringFormat))
        );
        break;
    }
  }

  public getMostPopularEventsMobile(sportId: number) {
    return this.eventsProvider.getMostPopularEventsMobile(sportId, ConstantValues.NUMBER_OF_INITIAL_EVENTS_PM, ViewConfigurations.showSpecialEventsInStandardOffer ? null : [EventMappingType.StandardEvent, EventMappingType.EventOfDay]).pipe(
      switchMap(async (res) => await this.getSportWithEventsAndSelections(res.sportWithEvents, null, this.utilityService.eventsDateToStringFormat))
    );
  }

  private async getSportWithEventsAndSelections(sportWithEventsList: ISportWithEventsAndSelectionsTO, specialOfferType: SpecialOfferType, dateToStringFormat: Intl.DateTimeFormatOptions): Promise<ISportWithEventsAndSelections> {
    const sportWithEventsAndSelections: ISportWithEventsAndSelections = {
      sport: null,
      events: {},
      selections: {}
    };

    const btst = await this.settingsService.getBetTypeShowTypes().toPromise();
    const sport = this.modelMapper.mapSport(sportWithEventsList.sport, 1, specialOfferType);
    sport.eventsCount = sportWithEventsList.events.length;
    sportWithEventsAndSelections.sport = sport;
    let i = 1;
    for (const ev of sportWithEventsList.events) {
      ev.orderNo = i;
      sportWithEventsAndSelections.events[ev.id] = this.modelMapper.mapEvent(ev, sportWithEventsList.sport.name, null, null, this.languageCulture, dateToStringFormat, true, this.cacheService.eventsForNotifications.includes(ev.id), btst);
      i++;
    }

    for (const [betTypeId, selectionTO] of Object.entries(sportWithEventsList.selections)) {
      sportWithEventsAndSelections.selections[betTypeId] = this.modelMapper.mapBetTypeSelection(selectionTO);
      const btosAndSvbDisplayType = await this.settingsService.getBetTypeOutcomesAndSbvDisplayTypeForSelection(sportWithEventsAndSelections.selections[betTypeId]);
      sportWithEventsAndSelections.selections[betTypeId].betTypeOutcomes = btosAndSvbDisplayType.betTypeOutcomes;
      sportWithEventsAndSelections.selections[betTypeId].sbvDispalyType = btosAndSvbDisplayType.sbvDisplayType;
    }

    return sportWithEventsAndSelections;
  }

  async getSportsWithEventsAndSelections(sportWithEventsList: ISportWithEventsAndSelectionsTO[], specialOfferType: SpecialOfferType, dateToStringFormat: Intl.DateTimeFormatOptions): Promise<ISportsWithEventsAndSelections> {
    const sporsWithEventsAndSelections: ISportsWithEventsAndSelections = {
      sports: [],
      events: {},
      selections: {}
    };
    const btst = await this.settingsService.getBetTypeShowTypes().toPromise();
    let i = 1;
    for (const spEvAndSel of sportWithEventsList) {
      const sport = this.modelMapper.mapSport(spEvAndSel.sport, i * 2, specialOfferType);
      sport.eventsCount = spEvAndSel.events.length;
      sporsWithEventsAndSelections.sports.push(sport);
      i++;
      for (const ev of spEvAndSel.events) {
        sporsWithEventsAndSelections.events[ev.id] = this.modelMapper.mapEvent(ev, spEvAndSel.sport.name, null, null, this.languageCulture, dateToStringFormat, true, this.cacheService.eventsForNotifications.includes(ev.id), btst);
      }

      for (const [betTypeId, selection] of Object.entries(spEvAndSel.selections)) {
        if (!sporsWithEventsAndSelections.selections[spEvAndSel.sport.id]) {
          sporsWithEventsAndSelections.selections[spEvAndSel.sport.id] = {};
        }
        sporsWithEventsAndSelections.selections[spEvAndSel.sport.id][betTypeId] = this.modelMapper.mapBetTypeSelection(selection);
        const btosAndSvbDisplayType = await this.settingsService.getBetTypeOutcomesAndSbvDisplayTypeForSelection(sporsWithEventsAndSelections.selections[spEvAndSel.sport.id][betTypeId]);
        sporsWithEventsAndSelections.selections[spEvAndSel.sport.id][betTypeId].betTypeOutcomes = btosAndSvbDisplayType.betTypeOutcomes;
        sporsWithEventsAndSelections.selections[spEvAndSel.sport.id][betTypeId].sbvDispalyType = btosAndSvbDisplayType.sbvDisplayType;
      }
    }

    return sporsWithEventsAndSelections;
  }

  getFinishedEventsResultsForSelection(timeFilterValue: TimeFilter, sport: ISport, region?: IRegion, competition?: ICompetition): Observable<IEvenResultsAndScoreGroups> {
    const dates = this.utilityService.getDateFromTo(false, timeFilterValue);
    return this.eventsProvider.getEventResults(dates.dateFrom, dates.dateTo, sport.id, region ? region.id : null, competition ? competition.id : null).pipe(
      switchMap((webEventResultsResponse) => of(this.modelMapper.mapEvenResultsAndScoreGroups(webEventResultsResponse, this.languageCulture, sport, region, competition))));
  }

  getEventsByDateAndCode(searchValue: string): Observable<EventVM[]> {
    return this.eventsProvider.getEventsByCodeOrNameSearch(searchValue).pipe(
      switchMap(async events => {
        const btst = await this.settingsService.getBetTypeShowTypes().toPromise();
        return events.map(ev =>
          this.modelMapper.mapEvent(
            ev,
            ev.sportName,
            ev.regionName,
            ev.competitionName,
            this.languageCulture,
            this.utilityService.eventsDateToStringFormat,
            false,
            false,
            btst));
      })
    );
  }

  getAllLiveEvents(): Observable<EventVM[]> {
    return this.eventsProvider.getAllLiveEvents().pipe(
      switchMap(async events => {
        const btst = await this.settingsService.getBetTypeShowTypes().toPromise();
        return events.map(ev =>
          this.modelMapper.mapEvent(
            ev,
            ev.sportName,
            ev.regionName,
            ev.competitionName,
            this.languageCulture,
            this.utilityService.eventsDateToStringFormat,
            false,
            false, btst)
        );
      })
    );
  }

  getBetsForEvent(event: EventVM, betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType }): Observable<{ bets: IBet[]; betOutcomes: IBetOutcome[] }> {
    return this.eventsProvider.getBetsForEvent(event).pipe(
      switchMap(async betsTO => {
        const bets: IBet[] = [];
        const betOutcomes: IBetOutcome[] = [];
        const btst = await this.settingsService.getBetTypeShowTypes().toPromise();
        for (const betTO of betsTO) {
          bets.push(this.modelMapper.mapBet(betTO, 0, event.isLive, false, btst[betTO.betTypeId]));
          for (const btoTO of betTO.betOutcomes) {
            const bto = this.modelMapper.mapBetOutcome(btoTO, btoTO.isLive);
            bto.isBetPlayable = bets[bets.length - 1].isPlayable && bets[bets.length - 1].isInOffer;
            // this.utilityService.getBetOutcomeNameFromBTO(bto, betTypeShowTypes[bto.betTypeId], event.homeTeam, event.awayTeam, event.eventType);
            betOutcomes.push(bto);
          }
        }
        return { bets, betOutcomes };
      })
    );
  }
}
